import React from 'react';
import Slider from "@material-ui/core/Slider";

const IvSlider = (props) => {
	const marks = [
		{value: 0, label: 'Any'},
		{value: 20, label: '20%+'},
		{value: 40, label: '40%+'},
		{value: 60, label: '60%+'},
		{value: 80, label: '80%+'},
		{value: 100, label: '100%'},
	];

	return (
		<Slider
			value={props.value}
			onChange={(e, val) => props.setValue(val)}
			valueLabelDisplay="off"
			aria-labelledby="discrete-slider-restrict"
			step={2.22222222222}
			marks={marks}
			min={0}
			max={100}
		/>
	);
};

export default IvSlider;